import { render } from "./TabEducation.vue?vue&type=template&id=6f35bd82"
import script from "./TabEducation.vue?vue&type=script&lang=js"
export * from "./TabEducation.vue?vue&type=script&lang=js"

import "./TabEducation.vue?vue&type=style&index=0&id=6f35bd82&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__